import { render, staticRenderFns } from "./dental_patients.vue?vue&type=template&id=1331d191&"
import script from "./dental_patients.vue?vue&type=script&lang=js&"
export * from "./dental_patients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports